"use client";

import { motion, useReducedMotion } from "motion/react";

export function InPracticeIndexFlair({
  indexLabel,
  motionDelay = 0,
}: {
  indexLabel: string;
  motionDelay?: number;
}) {
  const reduceMotion = useReducedMotion();

  return (
    <motion.div
      className="pointer-events-none relative flex min-h-[10rem] items-start justify-center lg:min-h-[16rem] lg:justify-end"
      aria-hidden
      initial={reduceMotion ? undefined : { opacity: 0, filter: "blur(8px)", scale: 0.94 }}
      whileInView={reduceMotion ? undefined : { opacity: 1, filter: "blur(0px)", scale: 1 }}
      viewport={{ once: true, amount: 0.35 }}
      transition={{
        duration: 0.55,
        delay: motionDelay,
        ease: [0.25, 1, 0.5, 1],
      }}
    >
      <div
        className="absolute inset-0 opacity-100 [background:radial-gradient(ellipse_72%_52%_at_70%_32%,color-mix(in_srgb,#c1c3ef_18%,transparent)_0%,transparent_58%)]"
        aria-hidden
      />
      <span
        className="relative select-none font-display text-[clamp(5.5rem,18vw,11.5rem)] font-medium leading-none tracking-tighter text-[color-mix(in_srgb,var(--primary)_13%,transparent)] tabular-nums motion-safe:transition-[transform,opacity] motion-safe:duration-700 motion-safe:ease-[var(--ease-out-quint)]"
        style={{ fontFamily: "var(--font-display)" }}
      >
        {indexLabel}
      </span>
    </motion.div>
  );
}
